module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeBAMAAAC/JAEaAAAAFVBMVEVHcEz///////////////////////+3ygHaAAAABnRSTlMAcvixrPzcQ1ODAAAAMklEQVQY02NIA4FkBiAwAzMZMAWClJSUVEACTkCGKlBAgAEJMA4eAfqAQet9zIgiFLcAr8AmyXsmwWkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/video_full_screen.png
// module id = L75b
// module chunks = 40